import { useContext } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney, parseJson } from "../Helpers";
import { MANUAL_IMPORTATION } from "../CoordinateSystems";

export default function View({ data }) {

  const appContext = useContext(AppContext);
  const cornerPoints = parseJson(data.cornerPoints, []);
  const isPolyline = cornerPoints.length === 2;

	function view(){
		appContext.navTo({
			item: 'view',
			subItem: 'order',
			extraItem: data.uuid,
		})
	}

	return (
		<div 
			className="bg-surface mShadow1"
			style={{
				width: "100%",
				marginBottom: "20px", 
				cursor: "pointer",
				borderRadius: "10px",
				overflow: "hidden",
				padding: "10px"
			}}
			onClick={view}
		>
			<h6
				style={{ fontSize: "16px" }}
				className="font-semi-bold"
			>
				{data.title || "Inquiry"}
			</h6>
			<span className={`badge ${data.pointsMappingMethod === MANUAL_IMPORTATION ? "bg-primary" : "bg-dark"}`}>
				{data.pointsMappingMethod === MANUAL_IMPORTATION ? "Manual import" : "Mobile GPS"}
			</span>

			<h6
				style={{ fontSize: "14px" }}
				className="text-muted mt-4"
			>
            {isPolyline ? "Line length" : "Area"}: <span className="text-primary font-bold">
              {formatMoney(isPolyline ? data.selectedPerimeterMeters : data.selectedAreaSqm)} {isPolyline ? "Meters" : "Square Meters"}
            </span>
			</h6>
			<h6
				style={{ fontSize: "14px" }}
				className="text-muted mb-4"
			>
            {isPolyline ? "Points" : "Perimeter"}: <span className="text-primary font-bold">
              {isPolyline ? cornerPoints.length : `${formatMoney(data.selectedPerimeterMeters)} Meters`}
            </span>
			</h6>
			<h6 className="text-muted" style={{ fontSize: "14px" }}>
				Requested services: <span className="font-bold">{Number(data.requestedServiceCount || 0)}</span>
			</h6>

			<h6
				style={{ fontSize: "10px" }}
				className="text-end font-bold text-muted"
			>
				{formatDate(data.dateCreated)}
			</h6>
		</div>
	)
}
